import { border } from 'polished';
var borderStyles = ['1px', 'solid'];
export var defaultBorder = border(...borderStyles);
export var defaultBorderTop = border('top', ...borderStyles);
export var defaultBorderRight = border('right', ...borderStyles);
export var defaultBorderBottom = border('bottom', ...borderStyles);
export var defaultBorderLeft = border('left', ...borderStyles);
//# sourceMappingURL=border.js.map